import React from 'react'

import loadable from '@loadable/component'

import(/* webpackPrefetch: true */ '@pages/Support')

const Support = loadable(() => import(/* webpackChunkName: "support" */'@pages/Support'), {
  resolveComponent: (components) => components.Support,
})

export function SupportAsync(): JSX.Element {
  return <Support fallback={<div>Loading...</div>} />
}

